/* ================================================== */
/* MENU → Events
/* ================================================== */

function menuEvents() {

	// Close / open menu
	$menuTrigger.click(function() {
		if ($menu.hasClass(openClass)) {
			closeMenu();
		} else {
			openMenu();
		}
	});

	// Open menu on tab enter
	$menuTrigger.on('keyup', function(event) {
		if (event.keyCode == 13) {
			if ($menu.hasClass(openClass)) {
				closeMenu();
			} else {
				openMenu();
			}
		}
	});

	// Close menu on esc
	$(document).on('keyup', function(event) {
		if (event.keyCode == 27 && $(menuMobileClass).is(':visible')) {
			if ($menu.hasClass(openClass) && $menu.attr('aria-expanded') == 'true') {
				closeMenu();
			}
		}
	});

}

$(document).ready(menuEvents());